module.exports = __webpack_public_path__ + "static/media/sass.50667875.png";